import { AppShell } from '@/components/layout/AppShell'
import { NotFoundSpotlight } from '@/components/motion/not-found/spotlight'
import { usePageMeta } from '@/hooks/use-page-meta';

/** Full-page 404 for any unmatched URL — beUI's cursor-spotlight variant
 * inside the shell, with the shell's own actions swapped for the app's
 * destinations. */
export function NotFound() {
  usePageMeta("Page not found — Aura", { noindex: true })
  return (
    <AppShell>
      <div className="flex justify-center py-16">
        <NotFoundSpotlight
          code="404"
          title="Page not found"
          description="The page you're looking for doesn't exist, was moved, or you may have followed a broken link."
          homeHref="/"
          homeLabel="Back to home"
          browseHref="/my-interviews"
          browseLabel="My interviews"
        />
      </div>
    </AppShell>
  )
}
